// ---------- ข้อความของ option ----------

export type TextOption = { value?: number | string | null; text?: string };

/** text ของ option ที่ value ตรงกัน ("" = ไม่พบ) */
export const optionText = (options: TextOption[] | undefined, value: unknown): string =>
  options?.find((option) => String(option.value) === String(value ?? ""))?.text ?? "";

// ---------- ค่าว่าง ----------

/** ข้อความ หรือ "-" เมื่อว่าง */
export const dash = (value?: string | null): string => (value ?? "").trim() || "-";
